import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '../index';
import DispensaryService from '../../common/api/dispensary.service';
import Dispensary from '../../common/model/Dispensary';
import Brand from '../../common/model/Brand';
import Budtender from '../../common/model/Budtender';


@Module({ dynamic: true, store, name: 'dispensary' })
class DispensaryModule extends VuexModule {
  dispensaryList: Array<Dispensary> = [];

  brandDispensaries: Array<Dispensary> = [];

  budtenders: Array<Budtender> = [];

  service = new DispensaryService();

  brands: Array<Brand> = [];

  // Set brand when budtender visits brand's site, or when admin enters portal.
  @Mutation
  SET_DISPENSARY_LIST(list) {
    this.dispensaryList = list;
  }

  @Mutation
  SET_BRAND_DISPENSARY_LIST(list) {
    this.brandDispensaries = list;
  }

  @Mutation
  SET_BUDTENDER_DISPENSARY_LIST(list) {
    this.budtenders = list;
  }

  @Mutation
  ADD_DISPENSARIES_TO_BRAND(dispensaries) {
    this.brandDispensaries = [...this.brandDispensaries, ...dispensaries];
  }

  @Mutation
  REMOVE_DISPENSARY_FROM_LIST(dispensaryId: string) {
    this.brandDispensaries = this.brandDispensaries.filter(el => el.id !== dispensaryId);
  }

  @Action
  async fetchDispensariesByState(state: string): Promise<void> {
    const params = { state };
    const response = await this.service.fetchByState({ params });
    if (!response) { return; }
    this.SET_DISPENSARY_LIST(response.data.data.states);
  }


  @Action
  async fetchDispensariesForBrand(brand_id: string): Promise<void> {
    const params = { brand_id };
    const response = await this.service.fetchDispensariesByBrand({ params });
    if (!response) { return; }
    this.SET_BRAND_DISPENSARY_LIST(response.data.data.dispensaries);
  }

  @Action({ rawError: true })
  async addDispensariesToBrand(payload: any): Promise<void> {
    const { chosenDispensaries } = payload;
    const { brandId } = payload;

    const dispensaries = chosenDispensaries.map(dispensary => dispensary.id);
    const params = { brandId, dispensaries };
    await this.service.addDispensariesToBrand(params);
    this.ADD_DISPENSARIES_TO_BRAND(chosenDispensaries);
  }

  @Action
  async removeDispensaryFromBrand(payload: any): Promise<void> {
    const { dispensaryId } = payload;
    const { brandId } = payload;
    const params = { brand_id: brandId, dispensary_id: dispensaryId };
    const response = await this.service.removeDispensaryFromBrand(params);
    if (!response) { return; }
    this.REMOVE_DISPENSARY_FROM_LIST(dispensaryId);
  }
}

export default getModule(DispensaryModule);
